import axios from "axios";
import Config from "../../../config";

const v2_actionDeletarCustomField = (fieldId) => {
    return axios({
        method: "put",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v2/crm/custom-fields/${fieldId}/deletar`
    });
};

export default v2_actionDeletarCustomField;
